export default __webpack_public_path__ + "img/logoBlanco.bae30e56.png";